// src/misc/googleSheets/googleSheetClient.js

import Papa from "papaparse";

export function buildSheetCsvUrl({ sheetId, gid }) {
  return `https://docs.google.com/spreadsheets/d/${sheetId}/export?format=csv&gid=${gid}`;
}

/**
 * Fetches a public Google Sheet tab as an array of objects keyed by header row.
 * Assumes first row is headers.
 */
export async function fetchSheetRows({ sheetId, gid }) {
  const url = buildSheetCsvUrl({ sheetId, gid });

  const res = await fetch(url, {
    method: "GET",
    cache: "no-store",
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch sheet CSV (${res.status})`);
  }

  const csvText = await res.text();

  const parsed = Papa.parse(csvText, {
    header: true,
    skipEmptyLines: true,
  });

  if (parsed.errors?.length) {
    // Keep it actionable in console
    console.warn("CSV parse warnings:", parsed.errors);
  }

  // parsed.data is array of objects using headers as keys
  return Array.isArray(parsed.data) ? parsed.data : [];
}
